// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7NCTv":[function(require,module,exports,__globalThis) {
/**
 * Created By Hensi Murcia
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _auth = require("firebase/auth");
var _app = require("firebase/compat/app");
var _appDefault = parcelHelpers.interopDefault(_app);
var _auth1 = require("firebase/compat/auth");
var _common = require("./common");
var _personPlaceholderSvg = require("url:../images/person_placeholder.svg");
var _personPlaceholderSvgDefault = parcelHelpers.interopDefault(_personPlaceholderSvg);
"use strict";
let user;
let isRecentLogin = false;
let isEmail;
let dvToast;
let dbUser;
let recaptchaVerifier;
$("document").ready(function() {
    initLs();
    initAuthLs();
});
/**
 * check if user logged in
 */ function initAuthLs() {
    if (window.location.search.includes("action=success")) isRecentLogin = true;
    (0, _appDefault.default).auth().onAuthStateChanged(function(data) {
        if (data) {
            //User is logged in
            user = data;
            initUi();
        } else {
            //User needs to log in
            let modLogin = document.getElementById("modLogin");
            (0, _common.setDisplay)(modLogin, "flex");
        }
    });
}
function initUi() {
    let spAcc = document.getElementById("spAcc");
    let ivUser = document.getElementById("ivUser");
    isEmail = user.email != null;
    spAcc.textContent = isEmail ? user.email : user.phoneNumber;
    ivUser.src = (0, _personPlaceholderSvgDefault.default);
    $(ivUser).on("error", function() {
        ivUser.src = (0, _personPlaceholderSvgDefault.default);
    });
    dbUser = (0, _appDefault.default).database().ref(`Users/${user.uid}`);
    dbUser.child("info").once("value", function(data) {
        if (data.exists) {
            let info = data.val();
            ivUser.src = info.profile_Image ? info.profile_Image : (0, _personPlaceholderSvgDefault.default);
        }
    });
}
function initLs() {
    dvToast = document.getElementById("toast");
    let btnLogin = document.getElementById("btnLogin");
    $(btnLogin).click(function() {
        window.location.replace("../login.html?action=manage");
    });
    let btnContinue = document.getElementById("btnContinue");
    let modDeleteAcc = document.getElementById("modDeleteAcc");
    let modPwVerify = document.getElementById("modPwVerify");
    let modPhoneVerify1 = document.getElementById("modPhoneVerify");
    $(btnContinue).click(function() {
        if (isRecentLogin) (0, _common.setDisplay)(modDeleteAcc, "flex");
        else if (isEmail) (0, _common.setDisplay)(modPwVerify, "flex");
        else {
            initCaptcha();
            (0, _common.setDisplay)(modPhoneVerify1, "flex");
        }
    });
    let btnPwContinue = modPwVerify.querySelector(".btnContinue");
    let btnPwCancel = modPwVerify.querySelector(".btnCancel");
    let inPw = document.getElementById("inPw");
    let modError = document.getElementById("modError");
    let btnOk = document.getElementById("btnOk");
    $(btnPwContinue).click(function() {
        let pw = inPw.value.trim();
        if (pw) {
            inPw.value = "";
            verifyEmail(pw, modDeleteAcc, modError);
            (0, _common.setDisplay)(modPwVerify, "none");
        } else {
            $(inPw).shake();
            (0, _common.showToast)("Cannot be empty", dvToast, null);
        }
    });
    $(btnPwCancel).click(function() {
        (0, _common.setDisplay)(modPwVerify, "none");
    });
    $(btnOk).click(function() {
        (0, _common.setDisplay)(modError, "none");
    });
    let btnPhoneContinue = modPhoneVerify1.querySelector(".btnContinue");
    let btnPhoneCancel = modPhoneVerify1.querySelector(".btnCancel");
    $(btnPhoneContinue).click(function() {
        verifyPhone(modPhoneVerify1, modDeleteAcc, modError);
    });
    $(btnPhoneCancel).click(function() {
        (0, _common.setDisplay)(modPhoneVerify1, "none");
    });
    let btnDeleteAcc = document.getElementById("btnDeleteAcc");
    let btnDelCancel = modDeleteAcc.querySelector(".btnCancel");
    $(btnDeleteAcc).click(function() {
        (0, _common.setDisplay)(modDeleteAcc, "none");
        deleteAccount();
    });
    $(btnDelCancel).click(function() {
        (0, _common.setDisplay)(modDeleteAcc, "none");
    });
    let btnOkSuccess = document.getElementById("btnOkSuccess");
    $(btnOkSuccess).click(function() {
        window.location.replace("../login.html");
    });
}
function initCaptcha() {
    let dvContainer = modPhoneVerify.querySelector("container");
    let params = {
        type: "image",
        size: "normal",
        badge: "bottomleft"
    };
    let recaptchaVerifier = new (0, _appDefault.default).auth.RecaptchaVerifier(dvContainer, params, (0, _appDefault.default).app());
    recaptchaVerifier.render();
}
function verifyPhone(modPhoneVerify1, modDeleteAcc, modError) {
    user.reauthenticateWithPhoneNumber(user.phoneNumber, recaptchaVerifier).then((confirmationResult)=>{
        let modVerifyCode = document.getElementById("modVerifyCode");
        let btnCodeVerify = modVerifyCode.querySelector("btnContinue");
        let inCode = document.getElementById("inCode");
        (0, _common.setDisplay)(modPhoneVerify1, "none");
        (0, _common.setDisplay)(modVerifyCode, "flex");
        $(btnCodeVerify).unbind();
        $(btnCodeVerify).click(function() {
            let code = inCode.value.trim();
            if (!code) {
                $(inCode).shake();
                (0, _common.showToast)("Cannot be empty", dvToast, null);
                return;
            }
            confirmationResult.confirm(code).then(function(userCredential) {
                //successfully verified
                isRecentLogin = true;
                inCode.value = "";
                (0, _common.setDisplay)(modVerifyCode, "none");
                (0, _common.setDisplay)(modDeleteAcc, "flex");
            }).catch((e)=>{
                inCode.value = "";
                (0, _common.setDisplay)(modVerifyCode, "none");
                (0, _common.setDisplay)(modError, "flex");
            });
        });
    }).catch((e)=>{
        (0, _common.setDisplay)(modPhoneVerify1, "none");
        (0, _common.setDisplay)(modError, "flex");
    });
}
function deleteAccount() {
    let modDeletingAcc = document.getElementById("modDeletingAcc");
    (0, _common.setDisplay)(modDeletingAcc, "flex");
    user.delete().then(()=>{
        let modSuccess = document.getElementById("modSuccess");
        (0, _common.setDisplay)(modSuccess, "flex");
        (0, _common.setDisplay)(modDeletingAcc, "none");
    }).catch((error)=>{
        let modError = document.getElementById("modError");
        let pMsg = document.getElementById("pMsg");
        pMsg.textContent = "Could not delete account";
        (0, _common.setDisplay)(modError, "flex");
        (0, _common.setDisplay)(modDeletingAcc, "none");
    });
}
function verifyEmail(pw, modDeleteAcc, modError) {
    let creds = (0, _appDefault.default).auth.EmailAuthProvider.credential(user.email, pw);
    user.reauthenticateWithCredential(creds).then(()=>{
        isRecentLogin = true;
        (0, _common.setDisplay)(modDeleteAcc, "flex");
    }).catch((error)=>{
        (0, _common.setDisplay)(modError, "flex");
    });
}
jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
    intShakes = intShakes || 4;
    intDistance = intDistance || 2;
    intDuration = intDuration || 500;
    this.each(function() {
        $(this).css("position", "relative");
        for(var x = 1; x <= intShakes; x++)$(this).animate({
            left: intDistance * -1
        }, intDuration / intShakes / 4).animate({
            left: intDistance
        }, intDuration / intShakes / 2).animate({
            left: 0
        }, intDuration / intShakes / 4);
    });
    return this;
};

},{"firebase/auth":"dZ6yw","firebase/compat/app":"bAwIZ","firebase/compat/auth":"hOIAn","./common":"jYzpo","url:../images/person_placeholder.svg":"XkgYq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dZ6yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("@firebase/auth");
parcelHelpers.exportAll(_auth, exports);

},{"@firebase/auth":"fIGSE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fIGSE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionCodeOperation", ()=>(0, _indexD90D2Ee5Js.A));
parcelHelpers.export(exports, "ActionCodeURL", ()=>(0, _indexD90D2Ee5Js.aj));
parcelHelpers.export(exports, "AuthCredential", ()=>(0, _indexD90D2Ee5Js.M));
parcelHelpers.export(exports, "AuthErrorCodes", ()=>(0, _indexD90D2Ee5Js.J));
parcelHelpers.export(exports, "EmailAuthCredential", ()=>(0, _indexD90D2Ee5Js.N));
parcelHelpers.export(exports, "EmailAuthProvider", ()=>(0, _indexD90D2Ee5Js.W));
parcelHelpers.export(exports, "FacebookAuthProvider", ()=>(0, _indexD90D2Ee5Js.X));
parcelHelpers.export(exports, "FactorId", ()=>(0, _indexD90D2Ee5Js.F));
parcelHelpers.export(exports, "GithubAuthProvider", ()=>(0, _indexD90D2Ee5Js.Z));
parcelHelpers.export(exports, "GoogleAuthProvider", ()=>(0, _indexD90D2Ee5Js.Y));
parcelHelpers.export(exports, "OAuthCredential", ()=>(0, _indexD90D2Ee5Js.Q));
parcelHelpers.export(exports, "OAuthProvider", ()=>(0, _indexD90D2Ee5Js._));
parcelHelpers.export(exports, "OperationType", ()=>(0, _indexD90D2Ee5Js.O));
parcelHelpers.export(exports, "PhoneAuthCredential", ()=>(0, _indexD90D2Ee5Js.U));
parcelHelpers.export(exports, "PhoneAuthProvider", ()=>(0, _indexD90D2Ee5Js.P));
parcelHelpers.export(exports, "PhoneMultiFactorGenerator", ()=>(0, _indexD90D2Ee5Js.n));
parcelHelpers.export(exports, "ProviderId", ()=>(0, _indexD90D2Ee5Js.q));
parcelHelpers.export(exports, "RecaptchaVerifier", ()=>(0, _indexD90D2Ee5Js.R));
parcelHelpers.export(exports, "SAMLAuthProvider", ()=>(0, _indexD90D2Ee5Js.$));
parcelHelpers.export(exports, "SignInMethod", ()=>(0, _indexD90D2Ee5Js.S));
parcelHelpers.export(exports, "TotpMultiFactorGenerator", ()=>(0, _indexD90D2Ee5Js.T));
parcelHelpers.export(exports, "TotpSecret", ()=>(0, _indexD90D2Ee5Js.o));
parcelHelpers.export(exports, "TwitterAuthProvider", ()=>(0, _indexD90D2Ee5Js.a0));
parcelHelpers.export(exports, "applyActionCode", ()=>(0, _indexD90D2Ee5Js.a8));
parcelHelpers.export(exports, "beforeAuthStateChanged", ()=>(0, _indexD90D2Ee5Js.y));
parcelHelpers.export(exports, "browserCookiePersistence", ()=>(0, _indexD90D2Ee5Js.a));
parcelHelpers.export(exports, "browserLocalPersistence", ()=>(0, _indexD90D2Ee5Js.b));
parcelHelpers.export(exports, "browserPopupRedirectResolver", ()=>(0, _indexD90D2Ee5Js.m));
parcelHelpers.export(exports, "browserSessionPersistence", ()=>(0, _indexD90D2Ee5Js.c));
parcelHelpers.export(exports, "checkActionCode", ()=>(0, _indexD90D2Ee5Js.a9));
parcelHelpers.export(exports, "confirmPasswordReset", ()=>(0, _indexD90D2Ee5Js.a7));
parcelHelpers.export(exports, "connectAuthEmulator", ()=>(0, _indexD90D2Ee5Js.L));
parcelHelpers.export(exports, "createUserWithEmailAndPassword", ()=>(0, _indexD90D2Ee5Js.ab));
parcelHelpers.export(exports, "debugErrorMap", ()=>(0, _indexD90D2Ee5Js.H));
parcelHelpers.export(exports, "deleteUser", ()=>(0, _indexD90D2Ee5Js.G));
parcelHelpers.export(exports, "fetchSignInMethodsForEmail", ()=>(0, _indexD90D2Ee5Js.ag));
parcelHelpers.export(exports, "getAdditionalUserInfo", ()=>(0, _indexD90D2Ee5Js.ar));
parcelHelpers.export(exports, "getAuth", ()=>(0, _indexD90D2Ee5Js.p));
parcelHelpers.export(exports, "getIdToken", ()=>(0, _indexD90D2Ee5Js.ao));
parcelHelpers.export(exports, "getIdTokenResult", ()=>(0, _indexD90D2Ee5Js.ap));
parcelHelpers.export(exports, "getMultiFactorResolver", ()=>(0, _indexD90D2Ee5Js.at));
parcelHelpers.export(exports, "getRedirectResult", ()=>(0, _indexD90D2Ee5Js.k));
parcelHelpers.export(exports, "inMemoryPersistence", ()=>(0, _indexD90D2Ee5Js.V));
parcelHelpers.export(exports, "indexedDBLocalPersistence", ()=>(0, _indexD90D2Ee5Js.i));
parcelHelpers.export(exports, "initializeAuth", ()=>(0, _indexD90D2Ee5Js.K));
parcelHelpers.export(exports, "initializeRecaptchaConfig", ()=>(0, _indexD90D2Ee5Js.v));
parcelHelpers.export(exports, "isSignInWithEmailLink", ()=>(0, _indexD90D2Ee5Js.ae));
parcelHelpers.export(exports, "linkWithCredential", ()=>(0, _indexD90D2Ee5Js.a3));
parcelHelpers.export(exports, "linkWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.l));
parcelHelpers.export(exports, "linkWithPopup", ()=>(0, _indexD90D2Ee5Js.e));
parcelHelpers.export(exports, "linkWithRedirect", ()=>(0, _indexD90D2Ee5Js.h));
parcelHelpers.export(exports, "multiFactor", ()=>(0, _indexD90D2Ee5Js.au));
parcelHelpers.export(exports, "onAuthStateChanged", ()=>(0, _indexD90D2Ee5Js.z));
parcelHelpers.export(exports, "onIdTokenChanged", ()=>(0, _indexD90D2Ee5Js.x));
parcelHelpers.export(exports, "parseActionCodeURL", ()=>(0, _indexD90D2Ee5Js.ak));
parcelHelpers.export(exports, "prodErrorMap", ()=>(0, _indexD90D2Ee5Js.I));
parcelHelpers.export(exports, "reauthenticateWithCredential", ()=>(0, _indexD90D2Ee5Js.a4));
parcelHelpers.export(exports, "reauthenticateWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.r));
parcelHelpers.export(exports, "reauthenticateWithPopup", ()=>(0, _indexD90D2Ee5Js.f));
parcelHelpers.export(exports, "reauthenticateWithRedirect", ()=>(0, _indexD90D2Ee5Js.j));
parcelHelpers.export(exports, "reload", ()=>(0, _indexD90D2Ee5Js.as));
parcelHelpers.export(exports, "revokeAccessToken", ()=>(0, _indexD90D2Ee5Js.E));
parcelHelpers.export(exports, "sendEmailVerification", ()=>(0, _indexD90D2Ee5Js.ah));
parcelHelpers.export(exports, "sendPasswordResetEmail", ()=>(0, _indexD90D2Ee5Js.a6));
parcelHelpers.export(exports, "sendSignInLinkToEmail", ()=>(0, _indexD90D2Ee5Js.ad));
parcelHelpers.export(exports, "setPersistence", ()=>(0, _indexD90D2Ee5Js.t));
parcelHelpers.export(exports, "signInAnonymously", ()=>(0, _indexD90D2Ee5Js.a1));
parcelHelpers.export(exports, "signInWithCredential", ()=>(0, _indexD90D2Ee5Js.a2));
parcelHelpers.export(exports, "signInWithCustomToken", ()=>(0, _indexD90D2Ee5Js.a5));
parcelHelpers.export(exports, "signInWithEmailAndPassword", ()=>(0, _indexD90D2Ee5Js.ac));
parcelHelpers.export(exports, "signInWithEmailLink", ()=>(0, _indexD90D2Ee5Js.af));
parcelHelpers.export(exports, "signInWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.s));
parcelHelpers.export(exports, "signInWithPopup", ()=>(0, _indexD90D2Ee5Js.d));
parcelHelpers.export(exports, "signInWithRedirect", ()=>(0, _indexD90D2Ee5Js.g));
parcelHelpers.export(exports, "signOut", ()=>(0, _indexD90D2Ee5Js.D));
parcelHelpers.export(exports, "unlink", ()=>(0, _indexD90D2Ee5Js.aq));
parcelHelpers.export(exports, "updateCurrentUser", ()=>(0, _indexD90D2Ee5Js.C));
parcelHelpers.export(exports, "updateEmail", ()=>(0, _indexD90D2Ee5Js.am));
parcelHelpers.export(exports, "updatePassword", ()=>(0, _indexD90D2Ee5Js.an));
parcelHelpers.export(exports, "updatePhoneNumber", ()=>(0, _indexD90D2Ee5Js.u));
parcelHelpers.export(exports, "updateProfile", ()=>(0, _indexD90D2Ee5Js.al));
parcelHelpers.export(exports, "useDeviceLanguage", ()=>(0, _indexD90D2Ee5Js.B));
parcelHelpers.export(exports, "validatePassword", ()=>(0, _indexD90D2Ee5Js.w));
parcelHelpers.export(exports, "verifyBeforeUpdateEmail", ()=>(0, _indexD90D2Ee5Js.ai));
parcelHelpers.export(exports, "verifyPasswordResetCode", ()=>(0, _indexD90D2Ee5Js.aa));
var _indexD90D2Ee5Js = require("./index-d90d2ee5.js");
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _component = require("@firebase/component");

},{"./index-d90d2ee5.js":"844GM","@firebase/app":"iO7sa","@firebase/util":"fHqXn","@firebase/logger":"kY52V","@firebase/component":"6VF6E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"XkgYq":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lMkQ1");

},{}]},["7NCTv"], "7NCTv", "parcelRequire460e", {})

//# sourceMappingURL=removeAccount.903373b8.js.map
